import { render, staticRenderFns } from "./UploadResumeFiles.vue?vue&type=template&id=08c21e72&scoped=true&"
import script from "./UploadResumeFiles.vue?vue&type=script&lang=ts&"
export * from "./UploadResumeFiles.vue?vue&type=script&lang=ts&"
import style0 from "./UploadResumeFiles.vue?vue&type=style&index=0&id=08c21e72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c21e72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VFileInput,VForm,VIcon,VProgressLinear,VRow})
